import { Component, ContentChild, EventEmitter, Inject, Input, Output, TemplateRef } from '@angular/core';
import { AuthService } from '@spotter/services/user/auth-service';
//import { environment } from '@env/environment';
import { TranslateModule } from '@ngx-translate/core';
//import { SpotterSharedModule } from '@spotter/spotter-shared.module';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { SPOTTER_ENV } from '@spotter/tokens/env.token';
import { SpotterEnvironment } from '@spotter/environments/environment.template';

@Component({
    selector: 'site-header',
    standalone: true,
    imports: [TranslateModule, CommonModule, NgbModule, RouterModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
    window = window;

    /** Custom content to display in the avatar dropdown. */
    @Input() navbarUserDropdownContent: TemplateRef<any> | null = null;


    /** An event fired when the user has selected to logout.  */
    @Output() logout = new EventEmitter<void>();

    /** An event fired when the user has clicked the mobile toggler. */
    @Output() mobileToggleClicked = new EventEmitter<void>();

    /** A site name to select the correct logo. */
    @Input() site: "spotter" | "restorer" | 'tracker' = "spotter";

    constructor(public auth: AuthService, @Inject(SPOTTER_ENV) public env: SpotterEnvironment) {
        console.log(window.location.hostname);
        
    }
}
